export default __webpack_public_path__ + "static/premioHome-b08a1a0156237c1affe93155f13fda82.png";